import React from 'react'
import useFetchEntitiesWithCache from '../hooks/useFetchEntitiesWithCache'

export const CacheWarmup = ({ children }: { children: React.ReactNode }) => {
    useFetchEntitiesWithCache('issue')
    useFetchEntitiesWithCache('company')
    useFetchEntitiesWithCache('warrant')
    useFetchEntitiesWithCache('news')

    return children
}
